import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './Faq.css';

const Faq = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Qué servicios ofrece Artelaser3D?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ofrecemos servicios profesionales de grabado láser e impresión 3D. Trabajamos con madera, acrílico, cuero, metal, y diversos materiales para impresión 3D como PLA, PETG, ABS y resina. Realizamos desde piezas unitarias hasta pequeñas series."
        }
      },
      {
        "@type": "Question",
        "name": "¿Dónde están ubicados?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Estamos ubicados en Asturias, España. Aunque nuestra base es asturiana, ofrecemos servicios de envío a toda la península y Baleares. También puedes recoger tu pedido directamente si prefieres un trato presencial."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto tardan en entregar un pedido?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Los plazos varían según el proyecto. Para trabajos sencillos, el plazo es de 24-48 horas. Proyectos más complejos pueden requerir 3-7 días hábiles. Siempre confirmamos el plazo exacto antes de comenzar y ofrecemos opciones de urgencia para proyectos que lo necesiten."
        }
      },
      {
        "@type": "Question",
        "name": "¿Necesito tener el diseño listo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No es necesario. Puedes traer tu propio diseño en formato vectorial (AI, EPS, SVG) para grabado láser, o STL/OBJ para impresión 3D. También ofrecemos servicio de diseño: cuéntanos tu idea y nosotros la convertimos en un archivo listo para producir."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuál es el pedido mínimo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No hay pedido mínimo. Realizamos desde una sola pieza hasta pequeñas series. Para volúmenes superiores a 50 unidades, consulta descuentos especiales. Cada proyecto es bienvenido, ya sea una pieza única o una producción mayor."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cómo puedo solicitar un presupuesto?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Puedes solicitar presupuesto a través de nuestro formulario web, por email a info@artelaser3d.es, o por teléfono/WhatsApp. Cuanta más información nos proporciones (medidas, materiales, cantidad, diseño), más preciso será el presupuesto. Respondemos en menos de 24 horas."
        }
      }
    ]
  };

  const faqCategories = [
    {
      title: 'General',
      questions: [
        {
          q: '¿Qué servicios ofrece Artelaser3D?',
          a: 'Ofrecemos servicios profesionales de grabado láser e impresión 3D. Trabajamos con madera, acrílico, cuero, metal, y diversos materiales para impresión 3D como PLA, PETG, ABS y resina. Realizamos desde piezas unitarias hasta pequeñas series.'
        },
        {
          q: '¿Dónde están ubicados?',
          a: 'Estamos ubicados en Asturias, España. Aunque nuestra base es asturiana, ofrecemos servicios de envío a toda la península y Baleares. También puedes recoger tu pedido directamente si prefieres un trato presencial.'
        },
        {
          q: '¿Trabajan con empresas o solo particulares?',
          a: 'Trabajamos con ambos. Tenemos experiencia tanto en proyectos personales (regalos, decoración) como en proyectos empresariales (prototipos, producción en serie, artículos promocionales, señalética).'
        }
      ]
    },
    {
      title: 'Grabado Láser',
      questions: [
        {
          q: '¿Qué materiales se pueden grabar con láser?',
          a: 'Trabajamos con una amplia variedad: madera (pino, roble, nogal, haya), acrílico y plexiglas, cuero y piel genuina, metal anodizado (principalmente aluminio), corcho, cartón, algunos plásticos y cristal con efecto esmerilado.'
        },
        {
          q: '¿Cuál es el tiempo de entrega para grabado láser?',
          a: 'Depende del volumen y complejidad del proyecto. Para trabajos sencillos, 24-48 horas. Proyectos más complejos pueden requerir 3-5 días hábiles. Siempre confirmamos el plazo antes de comenzar.'
        },
        {
          q: '¿Necesito proporcionar el diseño?',
          a: 'Puedes traer tu propio diseño en formato vectorial (AI, EPS, SVG) o te ayudamos a crearlo. También trabajamos con imágenes de alta calidad que vectorizamos para el grabado. Ofrecemos servicio de diseño si lo necesitas.'
        },
        {
          q: '¿Se puede grabar fotografías?',
          a: 'Sí, podemos grabar fotografías en escala de grises sobre madera, acrílico y otros materiales. El resultado es un efecto similar a una fotografía antigua con diferentes tonos según la intensidad del grabado.'
        }
      ]
    },
    {
      title: 'Impresión 3D',
      questions: [
        {
          q: '¿Qué diferencia hay entre FDM y resina?',
          a: 'FDM utiliza filamentos de plástico y es ideal para piezas grandes y resistentes. Es más económico y rápido. Resina ofrece mayor detalle y acabado superficial perfecto, ideal para piezas pequeñas y complejas como miniaturas o joyería.'
        },
        {
          q: '¿Puedo imprimir cualquier diseño 3D?',
          a: 'La mayoría de diseños 3D son imprimibles, pero deben estar correctamente preparados. Aceptamos archivos STL, OBJ y 3MF. Si tienes un modelo que necesita ajustes, también ofrecemos servicio de preparación de archivos.'
        },
        {
          q: '¿Cuánto tarda una impresión 3D?',
          a: 'Depende del tamaño y complejidad. Una pieza pequeña puede tardar 2-4 horas, mientras que proyectos grandes pueden necesitar 20+ horas. Siempre te damos un tiempo estimado antes de comenzar.'
        },
        {
          q: '¿Es resistente el material impreso?',
          a: 'Depende del material. PLA es rígido pero menos resistente al calor. PETG y ABS ofrecen mayor resistencia mecánica y térmica. Nylon y fibra de carbono son los más resistentes para aplicaciones exigentes. Te asesoramos sobre el mejor material según el uso.'
        }
      ]
    },
    {
      title: 'Pedidos y Envíos',
      questions: [
        {
          q: '¿Cuál es el pedido mínimo?',
          a: 'No hay pedido mínimo. Realizamos desde una sola pieza hasta pequeñas series. Para volúmenes superiores a 50 unidades, consulta descuentos especiales.'
        },
        {
          q: '¿Cómo puedo solicitar un presupuesto?',
          a: 'Puedes solicitar presupuesto a través de nuestro formulario web, por email a info@artelaser3d.es, o por teléfono/WhatsApp. Cuanta más información nos proporciones, más preciso será el presupuesto. Respondemos en menos de 24 horas.'
        },
        {
          q: '¿Hacen envíos?',
          a: 'Sí, enviamos a toda España (península y Baleares). Trabajamos con mensajería express para garantizar que tu pedido llegue en perfectas condiciones y en el menor tiempo posible. También puedes recoger en nuestras instalaciones en Asturias.'
        },
        {
          q: '¿Cuáles son las formas de pago?',
          a: 'Aceptamos transferencia bancaria, Bizum y PayPal. Para pedidos grandes, podemos acordar un porcentaje por adelantado y el resto contra entrega. Emitimos factura con IVA incluido para todos los pedidos.'
        }
      ]
    }
  ];

  return (
    <>
      <SEO 
        title="Preguntas Frecuentes"
        description="Resolvemos tus dudas sobre nuestros servicios de grabado láser e impresión 3D. Información sobre materiales, plazos, envíos y más."
        canonicalUrl="https://artelaser3d.es/preguntas-frecuentes"
        schema={schema}
      />

      <section className="page-hero page-hero--faq">
        <div className="page-hero__container">
          <span className="page-hero__badge">FAQ</span>
          <h1 className="page-hero__title">
            Preguntas
            <span className="text-primary"> frecuentes</span>
          </h1>
          <p className="page-hero__description">
            Resolvemos tus dudas sobre nuestros servicios de grabado láser e 
            impresión 3D. Si no encuentras tu respuesta, contáctanos.
          </p>
        </div>
      </section>

      <section className="section section--faq-content section--visible">
        <div className="section__container">
          {faqCategories.map((category, catIndex) => (
            <div key={catIndex} className="faq-category">
              <h2 className="faq-category__title">{category.title}</h2>
              
              <div className="faq-items">
                {category.questions.map((item, qIndex) => (
                  <article key={qIndex} className="faq-item-v2">
                    <h3 className="faq-item-v2__question">{item.q}</h3>
                    <p className="faq-item-v2__answer">{item.a}</p>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--contact-cta section--cta--faq section--visible">
        <div className="section__container">
          <div className="contact-cta-box">
            <h2 className="cta__title--faq">¿No encuentras tu respuesta?</h2>
            
            <p className="cta__description--faq">
              Estaremos encantados de resolver todas tus dudas personalmente. 
              Contáctanos y te responderemos lo antes posible.
            </p>

            <div className="contact-cta-box__buttons">
              <Link to="/contacto" className="btn btn--primary btn--lg">
                Contactar
              </Link>
              <a 
                href="mailto:info@artelaser3d.es" 
                className="btn btn--outline btn--lg"
              >
                Enviar Email
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
